<template>
  <div v-if="notifications.length" :class="getColorScheme()">
    <div :span="1" class="icon">
      <i class="fa fa-bell"></i>
    </div>

    <div class="notifications" @click="show_details = !show_details">
      <div :span="5" v-for="notification in notifications" class="col">
        <p v-if="!show_details" style="padding: 0; margin: 0">{{ formatTitle(notification.title) }}</p>
        <p v-else style="padding: 0; margin: 0">{{ notification.title }}</p>
        <p style="font-size: 0.8em; padding: 0; margin: 0">{{ notification.created_at | moment('DD.MM.YY') }}
          {{ notification.created_by.includes('Brandsafe') ? 'Brandsafe' : $t('office_name') }}
        </p>

        <div class="details" v-if="show_details">
          <p class="message" style="word-break: break-word;" v-html="notification.message"></p>

          <a class="link" :href="notification.link" target="_blank" v-if="notification.link">{{
              notification.hasOwnProperty('link_title') ? notification.link_title : notification.link
            }}</a>
        </div>
      </div>
    </div>

    <div class="notification-close" @click="show_details= false" v-if="show_details">
      <i class="fa fa-angle-up "></i>
    </div>
  </div>
</template>

<script>
import Axios from "axios";

export default {

  props: ['customer_id'],

  data() {
    return {
      notifications: [],
      show_details: false
    }
  },

  mounted() {
    this.getNotifications();
  },

  methods: {

    getColorScheme() {
      return 'notification-container' + (this.customer_id == 11 ? ' yellow' : '');
    },

    formatTitle(title) {
      if (title.length <= 30) {
        return title;
      }

      return title.substring(0, 30) + '...';
    },

    getNotifications() {
      Axios.get(process.env.VUE_APP_NOTIFICATION_URL, {headers: {'Authorization': 'Bearer ' + this.$cookies.get('bs_token')}}).then(response => {
        this.notifications = response.data;
        this.notification_loading = false;

        this.notifications.forEach(notification => {
          if (notification.start_date && notification.end_date) {
            notification.duration = [notification.start_date, notification.end_date];
          }
          notification.sticky = notification.sticky ? 1 : 0;
        });
      }, error => {
        //console.log(error);
      });
    },
  }


}
</script>

<style scoped>

.notification-container.yellow {
  background-color: #ffff99;
}

.notification-container {
  background-color: #F5F5F5;
  margin-top: -1px;
  position: relative;
}

.notifications {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-left: 60px;
  max-height: 60vh;
  overflow-y: auto;
}

.notification-container .icon {
  font-size: 1.2em;
  color: #263238;
  background-color: yellowgreen;
  text-align: center;
  height: 100%;
  padding: 20px;
  float: left;
  width: 60px;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
}

.notification-container .col {
  border-right: 1px solid #c0c0c0;
  padding: 15px;
  cursor: pointer;
  float: left;
  min-width: 200px;
  max-width: 350px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.notification-container.yellow .col {
  border-right: 1px solid #d3d347;
}

.notification-container .message {

}

.notification-container .details {
  margin-top: 25px;
  margin-bottom: 25px;
}

.notification-close {
  clear: both;
  padding: 25px 0 25px 0;
  text-align: center;
  font-size: 2.0em;
  color: yellowgreen;
  cursor: pointer;
}

</style>